// @flow
/**
 * User: Mike Chung
 * Date: 20/1/2018
 * Time: 5:10 PM
 */

import type {EBadgeQueryActionCollection, EBadgeQueryFailedAction} from "../actions/ebadge/eBadgeQueryAction";
import EBadge from "../model/ebadge/EBadge";
import type {EBadgeQueryCriteria} from "../model/ebadge/EBadgeQueryCriteria";
import type {EBadgeUnlockSuccessAction} from "../actions/ebadge/eBadgeUnlockAction";
import * as _ from "lodash";
import type {EBadgeLockSuccessAction} from "../actions/ebadge/eBadgeLockAction";
import type {ReducedError} from "../types/ErrorTypes";
import type {EBadgeButtonActionSuccessAction} from "../actions/ebadge/eBadgeButtonAction";

export type Warning = {
    message: string
}

export type EBadgeQueryState = {

    isLoading: boolean,
    eBadges: Array<EBadge>,
    totalResult: number,
    criteria: EBadgeQueryCriteria,
    error?: ReducedError,
    warning?: Warning
}

const INITIAL_STATE: EBadgeQueryState = {
    isLoading: false,
    eBadges: [],
    totalResult: -1,
    criteria: {
        email: undefined,
        firstName: undefined,
        lastName: undefined,
        page: 1,
        pageItem: 20
    }
};

function updateUnlockResult(action: EBadgeUnlockSuccessAction, state: EBadgeQueryState): EBadgeQueryState {
    const unlockAction = (action: EBadgeUnlockSuccessAction);
    let index = _.findIndex(state.eBadges, (e) => e.registrationCode === unlockAction.registrationCode);
    let targetBadge = state.eBadges[index];
    targetBadge.status = 'pending';
    targetBadge.unlockCount++;
    let result = [].concat(state.eBadges);
    result.splice(index, 1, targetBadge);

    return {
        ...state,
        isLoading: false,
        eBadges: result,
        error: undefined
    };
}

function updateLockResult(action: EBadgeLockSuccessAction, state: EBadgeQueryState): EBadgeQueryState {
    const lockAction = (action: EBadgeLockSuccessAction);
    let index = _.findIndex(state.eBadges, (e) => e.registrationCode === lockAction.registrationCode);
    let targetBadge = state.eBadges[index];
    targetBadge.status = 'redeemed';
    let result = [].concat(state.eBadges);
    result.splice(index, 1, targetBadge);

    return {
        ...state,
        isLoading: false,
        eBadges: result,
        error: undefined
    };
}

function handleEBadgeButtonActionSuccess(action: EBadgeButtonActionSuccessAction, state: EBadgeQueryState): EBadgeQueryState {
    let index = _.findIndex(state.eBadges, (e) => e.registrationCode === action.registrationCode);
    let targetBadge = state.eBadges[index];
    if (targetBadge) {

        switch (action.actionType) {
            case "validate":
                targetBadge.isVerifiedData = 'Y';
                break;
            case "invalidate":
                targetBadge.isVerifiedData = 'N';
                break;
            default:
                break;
        }
        let result = [].concat(state.eBadges);
        result.splice(index, 1, targetBadge);

        return {
            ...state,
            isLoading: false,
            eBadges: result,
            error: undefined
        }
    } else {
        return state
    }
}

let reduceError = function (state: EBadgeQueryState, action: EBadgeQueryFailedAction) {

    let reducedError: ReducedError = Object.assign({
        message: "Please at least select Year with Fair or input a Registration Code (15 digits)."
    }, action.error);

    return {
        ...state,
        isLoading: false,
        eBadges: [],
        error: reducedError
    };
};


type ActionCollection = EBadgeQueryActionCollection | EBadgeUnlockSuccessAction | EBadgeLockSuccessAction
    | EBadgeButtonActionSuccessAction;

export default function reducer(state: EBadgeQueryState = INITIAL_STATE, action: ActionCollection): EBadgeQueryState {

    switch (action.type) {
        case "ebadge/QUERY_START_ACTION":
            return {
                ...state,
                isLoading: true,
                criteria: action.criteria,
                error: undefined,
                warning: undefined
            };
        case "ebadge/QUERY_SUCCESS_ACTION":

            return {
                ...state,
                isLoading: false,
                totalResult: action.totalResult,
                eBadges: [].concat(action.eBadges),
                error: undefined
            };
        case "ebadge/QUERY_FAILED_ACTION":

            return reduceError(state, action);
        case "ebadge/UNLOCK_SUCCESS_ACTION":

            return updateUnlockResult(action, state);
        case "ebadge/LOCK_SUCCESS_ACTION":

            return updateLockResult(action, state);
        case "ebadge/QUERY_WARNING_ACTION":

            return {
                ...state,
                warning: Object.assign({}, action.warning)
            };
        case "ebadge/BUTTON_ACTION_SUCCESS_ACTION":
            return handleEBadgeButtonActionSuccess(action, state);
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/EBadgeQueryReducer.js